import { useGlobalContentStore } from '~/store/globalContent';
import useStoryblokAdmin from '~/composables/useStoryblokAdmin';

export default function useNonEcomGuard() {
  const globalContentStore = useGlobalContentStore();
  const { isInStoryblokAdmin } = useStoryblokAdmin();

  const isNonEcomSite = computed(() => globalContentStore.getIsNonEcomSite);
  const showAdminWarning = computed(() => isNonEcomSite.value && isInStoryblokAdmin());

  return {
    isNonEcomSite,
    showAdminWarning,
  };
}
